/*eslint-disable  no-unused-vars */
import axios from 'axios'
import {
  GET_TABLE_TO_SEND_EMAIL,
  SET_LOADING,
  GET_DATA_FOR_SELECT,
  GET_EMAIL_TEMPLATE,
  GET_EMAIL_TEMPLATES,
  GET_EMAIL_TEMPLATES_FOR_SELECT,
  GET_EMAIL_HISTORY_TABLE,
  CLEAR_TEMPLATE,
  GET_EMAIL_HISTORY_TOTAL_TABLE,
  GET_EMAIL_HISTORY_READ_TABLE,
  GET_EMAIL_HISTORY_FILTERS,
  GET_EMAIL_HISTORY_CLICK_TABLE,
  GET_EMAIL_HISTORY_REPORTS,
} from './types'
import { notificationDanger, notificationSuccess } from '../../../utils/customToastify'
import { axiosWithCustomBaseUrlGetMethod } from '../../../utils/axiosWithCustomBaseURL'

export const getTableToSendEmail = (filters, recipientType, emailRecipientList) => async (dispatch) => {
  try {
    const contact_division_id = filters.tableFilter.contact_division_id || null
    dispatch(setLoading())
    const response = await axios.post('/emails/table-to-send-email', {
      filters,
      recipientType,
      emailRecipientList,
      contact_division_id,
    })
    dispatch({
      type: GET_TABLE_TO_SEND_EMAIL,
      payload: response.data,
    })
  } catch (error) {
    dispatch(setLoading())
  }
}

export const addAll = (filters, table) => async (dispatch) => {
  const contact_division_id = filters.tableFilter.contact_division_id || null
  dispatch(setLoading())
  const response = await axios.get('/emails/add-all', { params: { filters, table, contact_division_id } })
  dispatch(setLoading())
  return response.data
}

export const changeContactEmailStatus = (data, filters, recipientType, emailRecipientList) => async (dispatch) => {
  const contact_division_id = filters.tableFilter.contact_division_id || null
  dispatch(setLoading())
  await axios.get('/emails/change-contact-email-status', {
    params: { data, filters, recipientType, contact_division_id },
  })
  await dispatch(getTableToSendEmail(filters, recipientType, emailRecipientList))
}

export const getEmailSenders = () => async (dispatch) => {
  const response = await axios.get(`/support-types/supportTypesForSelects`, {
    params: { types: [26], forSelect: true },
  })
  return response.data[0].data
}

export const getUsersDivisionsRolesForSelect = () => async (dispatch) => {
  const response = await axios.get('/emails/users-divisions-roles-for-select')
  dispatch({
    type: GET_DATA_FOR_SELECT,
    payload: response.data,
  })
}

export const saveEmailTemplate = (data, id) => async (dispatch) => {
  let response = {}
  dispatch(setLoading())
  if (id) {
    response = await axios.patch(`/emails/${id}`, data)
    notificationSuccess('Template successfully updated')
  } else {
    response = await axios.post('/emails', data)
    notificationSuccess('Template successfully created')
  }
  dispatch({
    type: GET_EMAIL_TEMPLATE,
    payload: response.data,
  })
}

export const deleteEmailTemplate = (id, filters) => async (dispatch) => {
  try {
    console.log(id)
    if (id) {
      await axios.delete(`/emails/${id}`)
      notificationSuccess('Template deleted successfully')
      if (filters) {
        dispatch(getEmailTemplatesPagination(filters))
      }
    }
  } catch (error) {
    notificationDanger('Deleting of email template failed')
  }
}

export const getEmailTemplate = (id) => async (dispatch) => {
  dispatch(setLoading())
  const response = await axios.get(`/emails/${id}`)
  dispatch({
    type: GET_EMAIL_TEMPLATE,
    payload: response.data,
  })
}

export const getEmailTemplatesPagination = (filters) => async (dispatch) => {
  dispatch(setLoading())
  const response = await axios.get('/emails', { params: { filters } })
  dispatch({
    type: GET_EMAIL_TEMPLATES,
    payload: response.data,
  })
}

export const getAllEmailTemplatesForSelect = () => async (dispatch) => {
  const response = await axios.get('/emails/templates-for-select')
  dispatch({
    type: GET_EMAIL_TEMPLATES_FOR_SELECT,
    payload: response.data,
  })
}

export const getDuplicateTemplate = (name) => async () => {
  const response = await axios.get('/emails/duplicates', { params: { name } })
  return response.data
}

export const sendEmail = (emailData, filterValues) => async (dispatch) => {
  dispatch(setLoading())
  await axios.post(`/emails/send-email`, emailData, { params: filterValues })
  dispatch(setLoading())
  notificationSuccess('Email successfully sent')
}

export const scheduleSendingEmail = (emailData, filterValues, sendingTime, closeModal) => async () => {
  const data = { ...emailData, sendingTime }
  const res = await axios.post('/emails/schedule-email', data, { params: filterValues })
  if (res.status === 200) {
    notificationSuccess('You have just scheduled sending email!')
    closeModal()
  }
}

export const addHistoryClick = (token, redirectUrl) => async (dispatch) => {
  const baseURL = `${
    process.env.REACT_APP_ENV === 'production'
      ? `${process.env.REACT_APP_BACKEND_URL}/api/v2`
      : 'http://localhost:5555/api/v2'
  }`
  const url = `/emails/add-click/${token}`
  const params = { redirectUrl }

  await axiosWithCustomBaseUrlGetMethod(url, params, baseURL)
}

export const getEmailHistoryTable = (options) => async (dispatch) => {
  dispatch(setLoading())
  const response = await axios.get('/emails/email-history-table', { params: options })
  if (response.status === 200)
    dispatch({
      type: GET_EMAIL_HISTORY_TABLE,
      payload: response.data,
    })
}

export const getEmailHistoryTotalTable = (options, historyID) => async (dispatch) => {
  dispatch(setLoading())
  const response = await axios.get(`/emails/email-history-total-table/${historyID}`, { params: options })
  if (response.status === 200)
    dispatch({
      type: GET_EMAIL_HISTORY_TOTAL_TABLE,
      payload: response.data,
    })
}

export const getEmailHistoryFilters = (historyID) => async (dispatch) => {
  const response = await axios.get(`/emails/email-history-filters/${historyID}`)
  if (response.status === 200) {
    dispatch({
      type: GET_EMAIL_HISTORY_FILTERS,
      payload: response.data,
    })
  }
}

export const getEmailHistoryReadTable = (options, historyID) => async (dispatch) => {
  dispatch(setLoading())
  const response = await axios.get(`/emails/email-history-read-table/${historyID}`, { params: options })
  if (response.status === 200)
    dispatch({
      type: GET_EMAIL_HISTORY_READ_TABLE,
      payload: response.data,
    })
}

export const getEmailHistoryClickTable = (options, historyID, linkId) => async (dispatch) => {
  dispatch(setLoading())
  const response = await axios.get(`/emails/email-history-click-table/${historyID}/${linkId}`, { params: options })
  if (response.status === 200)
    dispatch({
      type: GET_EMAIL_HISTORY_CLICK_TABLE,
      payload: response.data,
    })
}

export const getEmailHistoryReport = (historyID) => async (dispatch) => {
  dispatch(setLoading())
  const response = await axios.get(`/emails/email-history-report/${historyID}`)
  if (response.status === 200) {
    dispatch({
      type: GET_EMAIL_HISTORY_REPORTS,
      payload: response.data,
    })
  }
}

export const getLinks = (historyId) => async (dispatch) => {
  const response = await axios.get(`/emails/history-links/${historyId}`)
  return response.data
}

export const clearTemplate = () => (dispatch) => {
  dispatch({ type: CLEAR_TEMPLATE })
}

const setLoading = () => ({
  type: SET_LOADING,
})
